import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import API_URL from '../../config';

const Container = styled.div`
  margin-top: 20px;
`;

const DeletedDataContainer = styled.div`
  margin-top: 20px;
`;

const DeletedDataItem = styled.div`
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
`;

const RecoverButton = styled.button`
  background-color: transparent;
  color: var(--color-grey-100);
  border: none;
  padding: 3px 6px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 16px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  outline: none; 

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 300%;
    height: 300%;
    background-color: rgba(255, 255, 255, 0.01);
    transition: all 0.3s ease;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
  }

  &:hover {
    color: #eee;
    background-color: rgba(255, 255, 255, 0.1);

    &:before {
      width: 0;
      height: 0;
      transition: all 0.3s ease;
    }
  }

  &:disabled {
    cursor: not-allowed;
    background-color: #ccc;
    color: #666;
  }
`;

const SelectButton = styled.button`
  margin-right: 10px;
  background-color: transparent;
  color: var(--color-grey-100);
  border: none;
  padding: 3px 6px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  outline: none; 

  &:hover {
    background-color: darkred;
    color: white;
  }

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 300%;
    height: 300%;
    background-color: rgba(255, 255, 255, 0.01);
    transition: all 0.3s ease;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: #ccc;
    color: #666;
  }
`;

const DeletedDataList = () => {
  const [deletedData, setDeletedData] = useState([]);
  const [message, setMessage] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false); // State for "Select All"

  useEffect(() => {
    fetchDeletedData();
  }, []);

  const fetchDeletedData = async () => {
    try {
      const response = await fetch(`${API_URL}/deleted-blogs`);
      if (!response.ok) {
        throw new Error('Failed to fetch deleted data');
      }
      const data = await response.json();
      setDeletedData(data);
    } catch (error) {
      console.error('Error fetching deleted data:', error);
    }
  };

  const handleRecover = async (id) => {
    try {
      const response = await fetch(`${API_URL}/recover-blog/${id}`, {
        method: 'POST'
      });

      if (response.ok) {
        const updatedData = deletedData.filter(item => item.id !== id);
        setDeletedData(updatedData);
        setMessage(`${id} is recovered!`);
        setTimeout(() => setMessage(''), 5000); // Clear message after 5 seconds
      } else {
        console.error('Error recovering data:', response.statusText);
      }
    } catch (error) {
      console.error('Error recovering data:', error);
    }
  };

  const handleDeletePermanently = async () => {
    try {
      const response = await fetch(`${API_URL}/delete-permanently`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ ids: selectedItems })
      });

      if (response.ok) {
        const updatedData = deletedData.filter(item => !selectedItems.includes(item.id));
        setDeletedData(updatedData);
        setSelectedItems([]);
        setMessage(`${selectedItems.join(', ')} deleted permanently!`);
        setTimeout(() => setMessage(''), 5000); // Clear message after 5 seconds
      } else {
        console.error('Error permanently deleting data:', response.statusText);
      }
    } catch (error) {
      console.error('Error permanently deleting data:', error);
    }
  };

  const handleCheckboxChange = (id) => {
    const updatedSelectedItems = selectedItems.includes(id)
      ? selectedItems.filter(item => item !== id)
      : [...selectedItems, id];
    setSelectedItems(updatedSelectedItems);
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    const allIds = deletedData.map(item => item.id);
    setSelectedItems(selectAll ? [] : allIds);
  };

  return (
    <Container>
      <h2>Deleted Data</h2>
      <DeletedDataContainer>
        <p>{message}</p>
        {deletedData.map((item) => (<>
        <SelectButton onClick={handleSelectAll}>
          { selectAll ? 'Unselect All' : 'Select All'}
        </SelectButton>
          <DeletedDataItem key={item.id}>
            <input
              type="checkbox"
              checked={selectedItems.includes(item.id)}
              onChange={() => handleCheckboxChange(item.id)}
            />
            <div><b>ID: </b>{item.id}</div>
            <div><b>Title:</b> {item.title}</div>
            <div><b>Deleted at:</b> {item.deletedAt}</div>
            <div><b>Content:</b><br />
              <div style={{ height: '125px', overflowY: 'auto' }}> {item.content}</div>
            </div>
            <RecoverButton onClick={() => handleRecover(item.id)}>
              Recover
            </RecoverButton>
          </DeletedDataItem></>
        ))}
        <SelectButton onClick={handleDeletePermanently} disabled={selectedItems.length === 0}>
          Delete Permanently
        </SelectButton>
      </DeletedDataContainer>
    </Container>
  );
};

export default DeletedDataList;
